import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-submited-modal',
  templateUrl: './submited-modal.component.html',
  styleUrls: ['./submited-modal.component.css'],
})
export class SubmitedModalComponent {
  @Input() title: string = 'Request Submitted';
  @Input() message: string =
    'Your request has been submitted successfully. We will get back to you soon.';
  @Input() isOpen: boolean = false;
  @Output() close = new EventEmitter<void>();

  closeModal() {
    this.close.emit();
  }
}
